// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty_state-module__container--EFykW{padding:15px;display:table;table-layout:fixed}.empty_state-module__logo--2yKWK{width:35px;height:35px;margin-right:15px;display:table-cell}.empty_state-module__title--TY9vk{margin-bottom:5px;font-weight:500;color:#303030}.empty_state-module__content--TeNhK{display:table-cell;vertical-align:top;color:#999;font-size:13px;font-weight:400;font-size:14px;line-height:21px;letter-spacing:0}.empty_state-module__content--TeNhK a{color:#36b;cursor:pointer}.empty_state-module__content--TeNhK a:hover{color:#23537f;text-decoration:underline}\n", ""]);
// Exports
exports.locals = {
	"container": "empty_state-module__container--EFykW",
	"logo": "empty_state-module__logo--2yKWK",
	"title": "empty_state-module__title--TY9vk",
	"content": "empty_state-module__content--TeNhK"
};
module.exports = exports;
